module.exports = __webpack_public_path__ + "img/diners.67c67ef0.png";